import { YammerState } from '../../state/types';

type GetUserAcceptance = (state: YammerState) => boolean;
export const isUserAcceptanceRequired: GetUserAcceptance = (state) =>
  state.restrictedPostingAcceptance.requiresUserAcceptance;
